import e from"react";import{MUIAccordionSummary as t}from"./styles.js";import r from"@mui/icons-material/ExpandMore";const o=({title:o})=>e.createElement(t,{expandIcon:e.createElement(r,null)},o);export{o as default};
//# sourceMappingURL=AccordionSummary.js.map
